const initialState = () => ({
  campaignButton: false,
});

export { initialState as state };

export const getters = {
  getExperimentVariant: (state) => (experimentKey) => (
    state?.[experimentKey]
  ),
};

export const mutations = {
  set(state, data) {
    Object.keys(data).forEach((key) => {
      state[key] = data[key]; // eslint-disable-line no-param-reassign
    });
  },
};

export const actions = {
  async enroll({ commit }) {
    const enrollCampaignButton = async () => await this.$experiments.enroll('navbar-campaign') === 'enabled';

    // add any more global campaigns here
    const [campaignButton] = await Promise.all([
      enrollCampaignButton(),
    ]);
    commit('set', {
      campaignButton,
    });
  },
};
